module.exports = __webpack_public_path__ + "img/gallery03.ec09ce97.jpg";